{
  "{0} Invitation(s) successfully sent": "{0} Invitation(s) successfully sent",
  "{0} properties added to the brand": "{0} properties added to the brand",
  "{0} properties added to the cluster": "{0} properties added to the cluster",
  "{0} properties added to user": "{0} properties added to user",
  "{assigned} of {total} User assigned | {assigned} of {total} Users assigned": "{assigned} of {total} User assigned | {assigned} of {total} Users assigned",
  "{boldPart} To remove the page from a single property only, edit the page and remove that property's mapping rule instead.": "{boldPart} To remove the page from a single property only, edit the page and remove that property's mapping rule instead.",
  "{count} properties": "{count} properties",
  "{count} weren't updated": "{count} weren't updated",
  "{num} user(s) assigned to the property": "{num} user(s) assigned to the property",
  "{num} user(s) assigned to the site": "{num} user(s) assigned to the site",
  "1 wasn't updated": "1 wasn't updated",
  "A cluster or brand with this name already exists. Please, choose another one.": "A cluster or brand with this name already exists. Please, choose another one.",
  "A page with this name already exists. Please, choose another one.": "A page with this name already exists. Please, choose another one.",
  "A report will be sent by email every first week of the month summarizing the previous months data.": "A report will be sent by email every first week of the month summarizing the previous month's data.",
  "A report will be sent by email every week summarizing the previous weeks data.": "A report will be sent by email every week summarizing the previous week's data.",
  "A report will be sent by email summarizing the previous days data.": "A report will be sent by email summarizing the previous day's data.",
  "Access to data analytics on the Personalization Dashboard and BenchDirect for specific properties of the account": "Access to data analytics on the Personalization Dashboard and BenchDirect for specific properties of the account",
  "Access to operate in all products for specific properties of the account, without permission to edit settings": "Access to operate in all products for specific properties of the account, without permission to edit settings",
  "Account": "Account",
  "Account information": "Account information",
  "Account settings": "Account settings",
  "Account users": "Account users",
  "Account was successfully updated.": "Account was successfully updated.",
  "Action required: Please {link} to continue.": "Action required: Please {link} to continue.",
  "Activated": "Activated",
  "Add": "Add",
  "Add another set of rules": "Add another set of rules",
  "Add JavaScript condition": "Add JavaScript condition",
  "Add new notification": "Add new notification",
  "Add page": "Add page",
  "Add properties": "Add properties",
  "Add properties to this brand": "Add properties to this brand",
  "Add properties to this cluster": "Add properties to this cluster",
  "Add the email(s) of the user(s) you want to invite:": "Add the email(s) of the user(s) you want to invite:",
  "Add user(s) email...": "Add user(s) email...",
  "added": "added",
  "Admin": "Admin",
  "Adults Only": "Adults Only",
  "Agentic AI": "Agentic AI",
  "AI Visibility": "AI Visibility",
  "Airport Hotel": "Airport Hotel",
  "All": "All",
  "All data changes will be updated after 24hrs, so don’t worry if you don’t see your changes applied immediatly.": "All data changes will be updated after 24hrs, so don’t worry if you don’t see your changes applied immediately.",
  "All properties": "All properties",
  "All properties from all my accounts.": "All properties from all my accounts.",
  "All properties from this account selected.": "All properties from this account selected.",
  "All properties from this account.": "All properties from this account.",
  "All properties from your accounts selected.": "All properties from your accounts selected.",
  "All rules apply": "All rules apply",
  "All the properties were updated successfully.": "All the properties were updated successfully.",
  "All the sites were updated successfully.": "All the sites were updated successfully.",
  "All your properties have already been assigned to a brand group. Transfer properties from other brands if you want to populate a new brand group": "All your properties have already been assigned to a brand group. Transfer properties from other brands if you want to populate a new brand group",
  "All your team members have access to this property.": "All your team members have access to this property.",
  "All your team members have access to this site.": "All your team members have access to this site.",
  "An error occurred while sending the email. Please try again later.": "An error occurred while sending the email. Please try again later.",
  "An error occurred. Please try again": "An error occurred. Please try again",
  "analyst": "analyst",
  "Analyst": "Analyst",
  "Anchor": "Anchor",
  "Any rule applies": "Any rule applies",
  "Aparthotel": "Aparthotel",
  "Are you sure you want to delete this brand?": "Are you sure you want to delete this brand?",
  "Are you sure you want to delete this cluster?": "Are you sure you want to delete this cluster?",
  "Are you sure you want to proceed?": "Are you sure you want to proceed?",
  "Are you sure you want to remove the access?": "Are you sure you want to remove the access?",
  "Are you sure you want to remove this property from this brand?": "Are you sure you want to remove this property from this brand?",
  "Are you sure you want to remove this property from this cluster?": "Are you sure you want to remove this property from this cluster?",
  "Are you sure you want to remove this user from this account?": "Are you sure you want to remove this user from this account?",
  "Ask Ernest": "Ask Ernest",
  "Available languages": "Available languages",
  "B&B": "B&B",
  "Back": "Back",
  "Back to Pages": "Back to Pages",
  "Beach": "Beach",
  "BenchDirect": "BenchDirect",
  "Benchdirect": "BenchDirect",
  "Benchmark the key metrics of your direct booking channel": "Benchmark the key metrics of your direct booking channel",
  "Benchmark the key metrics of your direct channel": "Benchmark the key metrics of your direct channel",
  "Billing": "Billing",
  "Billing Account": "Billing Account",
  "Billing currency": "Billing currency",
  "Book multiplier": "Book multiplier",
  "Book Multiplier": "Book Multiplier",
  "Booking Engine Pages": "Booking Engine Pages",
  "Booking Engine pages include {pageExamples} and others. Your Booking Engine pages can't be edited. If you encounter any issues on these pages, please contact our Support team via chat.": "Booking Engine pages include {pageExamples} and others. Your Booking Engine pages can't be edited. If you encounter any issues on these pages, please contact our Support team via chat.",
  "Boutique": "Boutique",
  "Brand": "Brand",
  "Brand information": "Brand information",
  "Brand name": "Brand name",
  "Brands": "Brands",
  "Brands allow you to group your properties however you may need.": "Brands allow you to group your properties however you may need.",
  "Brands without any properties will be deleted after 30 days of inactivity": "Brands without any properties will be deleted after 30 days of inactivity",
  "Business": "Business",
  "Can’t access 1Password?": "Can’t access 1Password?",
  "Cancel": "Cancel",
  "Casino": "Casino",
  "Category (Stars)": "Category (Stars)",
  "Change password": "Change password",
  "Change the user role to adjust permissions": "Change the user role to adjust permissions",
  "Change your password": "Change your password",
  "Check Account Statement": "Check Account Statement",
  "Check the items that you want to copy.": "Check the items that you want to copy.",
  "Choose a beautiful picture of your hotel. This landing photo is used in multiple tools, whenever THN creates a page/email for the hotel. For example, in the Saved Searches email.": "Choose a beautiful picture of your hotel. This landing photo is used in multiple tools, whenever THN creates a page/email for the hotel. For example, in the Saved Searches email.",
  "Choose a beautiful picture of your site. This landing photo is used in multiple tools, whenever THN creates a page/email for the site. For example, in the Saved Searches email.": "Choose a beautiful picture of your site. This landing photo is used in multiple tools, whenever THN creates a page/email for the site. For example, in the Saved Searches email.",
  "Choose a product to start": "Choose a product to start",
  "Choose file": "Choose file",
  "Choose for which properties you'll upload URLs": "Choose for which properties you'll upload URLs",
  "Choose languages": "Choose languages",
  "City": "City",
  "Cluster Information": "Cluster Information",
  "Cluster name": "Cluster name",
  "Clusters": "Clusters",
  "Clusters allow you to group your hotels with the same cluster.": "Clusters allow you to group your hotels with the same cluster.",
  "Clusters allow you to group your properties however you may need.": "Clusters allow you to group your properties however you may need.",
  "Color": "Color",
  "Complete payment method": "Complete payment method",
  "Conference": "Conference",
  "Configure the communications that you want to receive from us through the link below. Apart from this configuration, you will receive relevant product news that may affect you.": "Configure the communications that you want to receive from us through the link below. Apart from this configuration, you will receive relevant product news that may affect you.",
  "Confirm": "Confirm",
  "Confirm new password": "Confirm new password",
  "Confirm password": "Confirm password",
  "Connect AI": "Connect AI",
  "Content": "Content",
  "Conversion": "Conversion",
  "Convince your visitors to book directly on your website": "Convince your visitors to book directly on your website",
  "Copied": "Copied",
  "Copied settings will be assigned to the selected properties:": "Copied settings will be assigned to the selected properties:",
  "Copied settings will be assigned to the selected sites:": "Copied settings will be assigned to the selected sites:",
  "Copy": "Copy",
  "Copy and paste this code just before the closing body tag {bodyTag} in all the funnel pages and any extra page where you want to use THN. If you have any doubt don't hesitate on contacting us.": "Copy and paste this code just before the closing body tag {bodyTag} in all the funnel pages and any extra page where you want to use THN. If you have any doubt don't hesitate on contacting us.",
  "Copy settings to other corporate sites": "Copy settings to other corporate sites",
  "Copy settings to other properties": "Copy settings to other properties",
  "Copy settings to other properties:": "Copy settings to other properties:",
  "Copy settings to other sites:": "Copy settings to other sites:",
  "Corporate": "Corporate",
  "Corporate landing picture": "Corporate landing picture",
  "Corporate logo": "Corporate Logo",
  "Corporate picture": "Corporate picture",
  "Corporate Sites": "Corporate Sites",
  "corporate sites": "corporate sites",
  "Create a Login item for your THN account. Click the three dots to the top right and choose “Scan QR code”. Find a {link}.": "Create a Login item for your THN account. Click the three dots to the top right and choose “Scan QR code”. Find a {link}.",
  "Create brand": "Create brand",
  "Create cluster": "Create cluster",
  "Create Login item and scan QR code": "Create Login item and scan QR code",
  "Create new brand": "Create new brand",
  "Create new cluster": "Create new cluster",
  "Create new corporate site": "Create new corporate site",
  "Create notification": "Create notification",
  "Create site": "Create site",
  "Create your account": "Sign up",
  "Create your first Corporate Site": "Create your first Corporate Site",
  "Currency and date format preferences when there’s not a property selected. This applies to Overview and brand page reports.": "Currency and date format preferences when there’s not a property selected. This applies to Overview and brand page reports.",
  "Currency format": "Currency format",
  "Currency in which you will see all the data for this corporate site.": "Currency in which you will see all the data for this corporate site.",
  "Currency in which you will see all the data for this property.": "Currency in which you will see all the data for this property.",
  "Currency used in your billing. To edit this contact your Client Success Agent": "Currency used in your billing. To edit this contact your Client Success Agent",
  "Currency used to display data in THN Products": "Currency used to display data in THN Products",
  "Current password": "Current password",
  "Daily": "Daily",
  "Daily:": "Daily: ",
  "Dashboard": "Dashboard",
  "Data about a particular {propertyType} or a particular user is never shared. The data is used to create competitive sets (groups of hotels that you can measure your performance against) and compare metrics between your hotels and their compsets. All data shown in BenchDirect is aggregate data.": "Data about a particular {propertyType} or a particular user is never shared. The data is used to create competitive sets (groups of hotels that you can measure your performance against) and compare metrics between your hotels and their compsets. All data shown in BenchDirect is aggregate data.",
  "Data updating": "Data updating",
  "Dates format": "Dates format",
  "Deactivated": "Deactivated",
  "Default currency": "Default currency",
  "Delete": "Delete",
  "Delete brand": "Delete brand",
  "Delete cluster": "Delete cluster",
  "Delete notification": "Delete notification",
  "Delete page": "Delete page",
  "Delete photo": "Delete photo",
  "Deleting the page will remove any active messages from it. Those messages will be active on any other pages they're assigned to.": "Deleting the page will remove any active messages from it. Those messages will be active on any other pages they're assigned to.\n\n",
  "Deleting this page will remove any active messages from it. Those messages will still be active on any other pages they're assigned to.": "Deleting this page will remove any active messages from it. Those messages will still be active on any other pages they're assigned to.",
  "Demand": "Demand",
  "demand_product_description": "Drive qualified traffic to your website through paid campaigns",
  "Didn't receive the email? {btn}": "Didn't receive the email? {btn}",
  "Disparities": "Disparities",
  "Display currency": "Display currency",
  "Do you already have an account? {btn}": "Already part of The Hotels Network? {btn}",
  "Do you want to compare your performance to the market and competition? Access our hotel benchmarking analytics platform.": "Do you want to compare your performance to the market and competition? Access our hotel benchmarking analytics platform.",
  "Do you want to delete this notification?": "Do you want to delete this notification?",
  "Do you want to delete this page?": "Do you want to delete this page?",
  "Do you want to get more direct bookings? Use personalization tools to tailor messages and offers according to each individual's behaviour.": "Do you want to get more direct bookings? Use personalization tools to tailor messages and offers according to each individual's behaviour.",
  "Don't remind me again": "Don't remind me again",
  "Don’t have an account? {btn}": "Don’t have an account? {btn}",
  "Download property list.": "Download property list.",
  "Download template": "Download template",
  "Drive qualified traffic to your hotel's website and effortlessly boost conversions thanks to our cutting-edge demand platform and fully-managed marketing services. Request a demo.": "Drive qualified traffic to your hotel's website and effortlessly boost conversions thanks to our cutting-edge demand platform and fully-managed marketing services. Request a demo.",
  "Drop files here": "Drop files here",
  "Drop icon": "Drop icon",
  "Each property can only use one mapping rule type per page, and they're already set to a different rule. Remove their existing rule first and import again.": "Each property can only use one mapping rule type per page, and they're already set to a different rule. Remove their existing rule first and import again.",
  "Edit": "Edit",
  "Edit account role": "Edit account role",
  "Edit brand": "Edit brand",
  "Edit cluster": "Edit cluster",
  "Edit notification": "Edit notification",
  "Edit payment method": "Edit payment method",
  "Edit Property": "Edit property",
  "Edit role": "Edit role",
  "Edit site": "Edit site",
  "Edit user": "Edit user",
  "Editing properties": "Editing properties",
  "Editing sites": "Editing sites",
  "Editing successful!": "Editing successful!",
  "Editing unsuccessful!": "Editing unsuccessful!",
  "Email": "Email",
  "Email communications from THN": "Email communications from THN",
  "Email notifications": "Email notifications",
  "Empty": "Empty",
  "English": "English",
  "english": "english",
  "English selected by default": "English selected by default",
  "Enter a 6-digit code": "Enter a 6-digit code",
  "Enter a description for the site": "Enter a description for the site",
  "Enter a password": "Enter a password",
  "Enter a password with at least 8 characters": "Enter a password with at least 8 characters",
  "Enter the code from 1Password to verify your identity.": "Enter the code from 1Password to verify your identity.",
  "Enter the email address related to this account and we'll send you the instructions to reset your password.": "Enter the email address related to this account and we'll send you the instructions to reset your password.",
  "Enter your account name": "Enter your account name",
  "Enter your code": "Enter your code",
  "Enter your current password": "Enter your current password",
  "Enter your email": "Enter your email",
  "Enter your last name": "Enter your last name",
  "Enter your name": "Enter your name",
  "Enter your password": "Enter your password",
  "Experience the power of next-gen AI across our products": "Experience the power of next-gen AI across our products",
  "Family": "Family",
  "First name": "First name",
  "follow these instructions": "follow these instructions",
  "Forgot your password?": "Forgot your password?",
  "Forgot your password? {btn}": "Forgot your password? {btn}",
  "Frequency": "Frequency",
  "Full access to all products as well as edit and manage all properties, invite users and assign roles": "Full access to all products as well as edit and manage all properties, invite users and assign roles",
  "General preferences": "General preferences",
  "Get a digest in your inbox and keep track of your disparities.": "Get a summary in your inbox and keep track of OTA and Meta Searcher disparities.",
  "Get more info": "Get more info",
  "Get the summary of the percentage change in each of the metrics: conversion, bookings, rates (BAR) and disparities.": "Get the summary of the percentage change in each of the metrics: conversion, bookings, rates (BAR) and disparities.",
  "Get your summary report directly in your inbox!": "Get your summary report directly in your inbox!",
  "Go back": "Go back",
  "Go to Help Center": "Go to Help Center",
  "Golf": "Golf",
  "Google Analytics": "Google Analytics",
  "Group your properties by brand!": "Group your properties by brand!",
  "Having trouble with your data?": "Having trouble with your data?",
  "help center": "help center",
  "Here you have a summary of some of the most common errors. Check it out!": "Here you have a summary of some of the most common errors. Check it out!",
  "Hostel": "Hostel",
  "Hotel address": "Hotel address",
  "Hotel information": "Hotel information",
  "Hotel landing picture": "Hotel landing picture",
  "Hotel logo": "Hotel logo",
  "Hotel profile": "Hotel profile",
  "Hotel Profile": "Hotel Profile",
  "Hotel type": "Hotel type",
  "How is the data used and processed?": "How is the data used and processed?",
  "I agree to the terms and conditions of the {privacyPolicyLink}": "I agree to the terms and conditions of the {privacyPolicyLink}",
  "I have already scanned it": "I have already scanned it",
  "If enabled, every time widgets are shown an event will be created in Google Analytics.": "If enabled, every time widgets are shown an event will be created in Google Analytics.",
  "If the email matches the one we have on your account, you will receive an email with the password recovery instructions shortly. Please make sure to refresh your inbox.": "If the email matches the one we have on your account, you will receive an email with the password recovery instructions shortly. Please make sure to refresh your inbox.",
  "If you are using Google Tag Manager (GTM), please {link} once you activate this setting.": "If you are using Google Tag Manager (GTM), please {link} once you activate this setting.",
  "If you remove this property, the brand will be empty and automatically deleted.": "If you remove this property, the brand will be empty and automatically deleted.",
  "If you remove this property, the cluster will be empty and automatically deleted.": "If you remove this property, the cluster will be empty and automatically deleted.",
  "Import": "Import",
  "Import URLs in bulk": "Import URLs in bulk",
  "Inactive": "Inactive",
  "Incorrect email or password. Please try again or {link}.": "Incorrect email or password. Please try again or {link}.",
  "Info": "Info",
  "Install and login to the 1Password extension.": "Install and login to the 1Password extension.",
  "Install the 1Password browser extension": "Install the 1Password browser extension",
  "Install the THN Script on your website": "Install the THN Script on your website",
  "Integration": "Integration",
  "Integration setup": "Integration setup",
  "Invalid CSV format.": "Invalid CSV format.",
  "Invalid or expired code, try again.": "Invalid or expired code, try again.",
  "Invitation couldn't be sent": "Invitation couldn't be sent",
  "Invitation successfully sent.": "Invitation successfully sent.",
  "Invite link expired": "Invite link expired",
  "Invite new user(s)": "Invite new user(s)",
  "Invite users": "Invite users",
  "Invoices": "Invoices",
  "It looks like this invite link has expired. Please check with your account owner or your Client Success Specialist if you need help.": "It looks like this invite link has expired. Please check with your account owner or your Client Success Specialist if you need help.",
  "It looks like this link has already been used or has expired.": "It looks like this link has already been used or has expired.",
  "JavaScript condition is": "JavaScript condition is",
  "KITT": "KITT",
  "Language": "Language",
  "Language direction": "Language direction",
  "Languages in which your website is available. When you create notes or other texts, you will see a box to enter the translations for each of these languages.": "Languages in which your website is available. When you create notes or other texts, you will see a box to enter the translations for each of these languages.",
  "Last name": "Last name",
  "Left to right": "Left to right",
  "Leisure": "Leisure",
  "Loading ...": "Loading ...",
  "Log out": "Log out",
  "Login": "Login",
  "Logo": "Logo",
  "Looks like you are the only one in the account": "Looks like you are the only one in the account",
  "Luxury": "Luxury",
  "Manage languages": "Manage languages",
  "Manage Preferences": "Manage Preferences",
  "Manage the access to properties for this user.": "Manage the access to properties for this user.",
  "Mapped for": "Mapped for",
  "Mapping Rules": "Mapping Rules",
  "Mapping Values": "Mapping Values",
  "Meet Ernest": "Meet Ernest",
  "Monthly": "Monthly",
  "Monthly:": "Monthly: ",
  "More information here": "More information here",
  "Motel": "Motel",
  "Must accept terms and conditions": "Must accept terms and conditions",
  "Must have at least 1 lowercase, 1 uppercase, 1 numeric character and length must be between 8 and 20.": "Must have at least 1 lowercase, 1 uppercase, 1 numeric character and length must be between 8 and 20.",
  "Name": "Name",
  "New password": "New password",
  "Next": "Next",
  "No account available with the name: {name}": "No account available with the name: {name}",
  "No brand created yet": "No brand created yet",
  "No data found": "No data found",
  "No mapping rules match the selected properties.": "No mapping rules match the selected properties.",
  "No matches found for your search": "No matches found for your search",
  "Nº of rooms": "Nº of rooms",
  "No properties": "No properties",
  "No properties available.": "No properties available.",
  "No properties found in this account": "No properties found in this account",
  "No valid rows found.": "No valid rows found.",
  "None": "None",
  "Not now": "Not now",
  "Notification created.": "Notification created.",
  "Notification icon": "Notification icon",
  "Notification was deleted.": "Notification was deleted.",
  "Notification was saved.": "Notification was saved.",
  "Notifications": "Notifications",
  "Now selected:": "Now selected:",
  "Now you can access to our products and boost your hotel direct bookings.": "Now you can access to our products and boost your hotel direct bookings.",
  "of": "of",
  "Ok": "Ok",
  "Once deleted, it can't be restored.": "Once deleted, it can't be restored.",
  "Only images are allowed": "Only images are allowed",
  "Oops! You don't have access to any account": "Oops! You don't have access to any account",
  "Oops! You don't have access to any property or product. Please contact the person responsible for THN within your team.": "Oops! You don't have access to any property or product. Please contact the person responsible for THN within your team.",
  "Operator": "Operator",
  "Ops, something went wrong. Please try again later.": "Ops, something went wrong. Please try again later.",
  "optional": "optional",
  "or": "or",
  "Overview of all properties": "Overview of all properties",
  "Overview preferences": "Overview preferences",
  "Owner": "Owner",
  "Ownership couldn't be transferred.": "Ownership couldn't be transferred.",
  "Ownership successfully transferred.": "Ownership successfully transferred.",
  "Page deleted successfully": "Page deleted successfully",
  "Page ID": "Page ID",
  "Page name": "Page name",
  "Page saved successfully": "Page saved successfully",
  "Pages": "Pages",
  "Pages created rely on the THN Script being installed to collect data and display your messages on the corresponding pages of your site.": "Pages created rely on the THN Script being installed to collect data and display your messages on the corresponding pages of your site.",
  "Password": "Password",
  "Password reset sent": "Password reset sent",
  "Passwords do not match": "Passwords do not match",
  "Pending confirmation": "Pending confirmation",
  "Personal information": "Personal information",
  "Personalization": "Personalization",
  "Personalize the user experience to boost conversion rates": "Personalize the user experience to boost conversion rates",
  "Personalize your hotel website's full funnel": "Personalize your hotel website's full funnel",
  "Please, complete the following information:": "Please, complete the following information:",
  "Please, contact {btn}": "Please, contact {btn}",
  "Please, contact the person responsible for THN within your team.": "Please, contact the person responsible for THN within your team.",
  "Please, introduce your current password and then set a new one": "Please, introduce your current password and then set a new one",
  "Please, retry to edit these properties.": "Please, retry to edit these properties.",
  "Please, retry to edit these sites.": "Please, retry to edit these sites.",
  "Please, select the account in which you want to log in:": "Please, select the account in which you want to log in:",
  "Please, select the brand to allocate this property:": "Please, select the brand to allocate this property:",
  "Please, select the cluster to allocate this property:": "Please, select the cluster to allocate this property:",
  "Please, try again": "Please, try again",
  "Preferences": "Preferences",
  "Priority": "Priority",
  "Privacy Policy": "Privacy Policy",
  "Profile": "Profile",
  "Properties": "Properties",
  "properties": "properties",
  "Properties included": "Properties included",
  "Properties selected": "Properties selected",
  "Property": "Property",
  "Property access": "Property access",
  "Property name": "Property name",
  "Property's script": "Corporate Site's script",
  "QR code for two-factor authentication setup": "QR code for two-factor authentication setup",
  "Query strings and jump links are not allowed, e.g. /en/rooms": "Query strings and jump links are not allowed, e.g. /en/rooms",
  "Ready to take your hotel's direct booking strategy to new heights?": "Ready to take your hotel's direct booking strategy to new heights?",
  "Recipients": "Recipients",
  "RegExp": "RegExp",
  "RegExp contains": "RegExp contains",
  "Remind to this user to accept the invitation you sent to join the account.": "Remind to this user to accept the invitation you sent to join the account.",
  "Remove access": "Remove access",
  "Remove from brand": "Remove from brand",
  "Remove from cluster": "Remove from cluster",
  "Remove properties and delete brand": "Remove properties and delete brand",
  "Remove properties and delete cluster": "Remove properties and delete cluster",
  "Remove property": "Remove property",
  "Remove property filter to add rule sets": "Remove property filter to add rule sets",
  "Remove user": "Remove user",
  "Removed access to {0} properties": "Removed access to {0} properties",
  "Removing {0} of {1}": "Removing {0} of {1}",
  "Repeat password": "Repeat password",
  "Reset password link expired": "Reset password link expired",
  "Reset your password": "Reset your password",
  "Resort": "Resort",
  "Restricted property": "Restricted property",
  "Return to login": "Return to login",
  "Right to left": "Right to left",
  "Role": "Role",
  "Rooms and Rates, Booking Confirmed, User Register Page": "Rooms and Rates, Booking Confirmed, User Register Page",
  "Save changes": "Save changes",
  "Save new page": "Save new page",
  "Save selection": "Save selection",
  "Search": "Search",
  "Search ...": "Search ...",
  "Search account": "Search account",
  "Search brand...": "Search brand...",
  "Search cluster...": "Search cluster...",
  "Search properties ...": "Search properties ...",
  "Search users...": "Search users...",
  "Search...": "Search...",
  "Seems like there aren’t any brands created yet": "Seems like there aren’t any brands created yet",
  "Seems like there aren’t any clusters created yet": "Seems like there aren’t any clusters created yet",
  "Select a product": "Select a product",
  "Select only languages that are available in your hotel website": "Select only languages that are available in your hotel website",
  "Select properties": "Select properties",
  "Select property": "Select property",
  "Select role for the user(s):": "Select role for the user(s):",
  "Select sites": "Select sites",
  "Select the properties that you want to add to this brand:": "Select the properties that you want to add to this brand:",
  "Select the properties you want the notifications from:": "Select the properties you want the notifications from:",
  "Select the properties you want to add to this brand:": "Select the properties you want to add to this brand:",
  "Select the properties you want to add to this cluster:": "Select the properties you want to add to this cluster:",
  "Select the properties you want to assign to this user(s):": "Select the properties you want to assign to this user(s):",
  "Select the type of notification:": "Select the type of notification:",
  "Select the user(s) you want to share this property with:": "Select the user(s) you want to share this property with:",
  "Select the user(s) you want to share this site with:": "Select the user(s) you want to share this site with:",
  "selected": "selected",
  "Send a new one": "Send a new one",
  "Send a reminder": "Send a reminder",
  "Send invite(s)": "Send invite(s)",
  "Send periodic reports to anyone you wish": "Send periodic reports to anyone you wish",
  "Send reminder": "Send reminder",
  "Send reset instructions": "Send reset instructions",
  "Set a new one here": "Set a new one here",
  "Set new password": "Set new password",
  "Set up 1Password 2FA": "Set up 1Password 2FA",
  "Set up your customized reports, select the frequency your prefer, the properties to look at and share it with as many people as you want.": "Set up your customized reports, select the frequency your prefer, the properties to look at and share it with as many people as you want.",
  "Set your new password": "Set your new password",
  "Settings": "Settings",
  "Share": "Share",
  "Share property": "Share property",
  "Share site": "Share site",
  "Show all": "Show all",
  "Sign in": "Sign in",
  "Sign in here": "Sign in here",
  "Sign up to join": "Sign up to join",
  "Single Apartment": "Single Apartment",
  "Site information": "Site Information",
  "Site logo": "Site logo",
  "Sites selected": "Sites selected",
  "Ski Resort": "Ski Resort",
  "Something went wrong. Please try again or contact support via chat if the issue persists.": "Something went wrong. Please try again or contact support via chat if the issue persists.",
  "Specific properties": "Specific properties",
  "Specific properties from this account.": "Specific properties from this account.",
  "Start grouping your properties however you like!": "Start grouping your properties however you like!",
  "Start inviting users to your team.": "Start inviting users to your team.",
  "step by step guide here": "step by step guide here",
  "Subscriptions list": "Subscriptions list",
  "Take a tour": "Take a tour",
  "Team": "Team",
  "The account does not exist": "The account does not exist",
  "The AI teammate that delivers intelligence, recommends your next move, and helps you act.": "The AI teammate that delivers intelligence, recommends your next move, and helps you act.",
  "The chatbot cannot be initialised": "The chatbot cannot be initialised",
  "The field length must be between 1 and 60 characters long.": "The field length must be between 1 and 60 characters long.",
  "The properties included will immediately become available to regroup in new brands.": "The properties included will immediately become available to regroup in new brands.",
  "The user already belongs to this account": "The user already belongs to this account",
  "The user has been locked out due to too many failed authentication attempts. Please {link} to continue.": "The user has been locked out due to too many failed authentication attempts. Please {link} to continue.",
  "The user will no longer have access to the properties.": "The user will no longer have access to the properties.",
  "There was an error deleting the page": "There was an error deleting the page",
  "There was an error loading the page": "There was an error loading the page",
  "There was an error saving the page": "There was an error saving the page",
  "These pages are managed automatically": "These pages are managed automatically",
  "This action cannot be undone.": "This action cannot be undone.",
  "This field is required": "This field is required",
  "This field must be a valid email": "This field must be a valid email",
  "This field must be a valid regular expression, e.g. restaurant|bar": "This field must be a valid regular expression, e.g. restaurant|bar",
  "This field must be a valid URL, e.g. https://hotel.com": "This field must be a valid URL, e.g. https://hotel.com",
  "This field must be at least {min} characters": "This field must be at least {min} characters",
  "This hotel is not currently activated, so messages will not appear on the website. To activate it, please contact your account manager.": "This hotel is not currently activated, so messages will not appear on the website. To activate it, please contact your account manager.",
  "This image will be used for reports, notifications and other account communications.": "This image will be used for reports, notifications and other account communications.",
  "This is your THN tracking code for {propertyName}. This script allows us to track and follow the complete booking funnel throughout your website and analyze the right metrics of your direct booking performance, as well as display all the widgets and messages you configure.": "This is your THN tracking code for {propertyName}. This script allows us to track and follow the complete booking funnel throughout your website and analyze the right metrics of your direct booking performance, as well as display all the widgets and messages you configure.",
  "This page is mapped to multiple properties, deleting it will delete the page for all of those properties.": "This page is mapped to multiple properties, deleting it will delete the page for all of those properties.",
  "This user already has access to all properties, you cant add more.": "This user already has access to all properties, you can't add more.",
  "This user will no longer be able to access to this/these property(ies).": "This user will no longer be able to access to this/these property(ies).",
  "Timeshare": "Timeshare",
  "Timezone": "Timezone",
  "Title": "Title",
  "To remove the page from a single property only, edit the page and remove that property's mapping rule instead.": "To remove the page from a single property only, edit the page and remove that property's mapping rule instead.",
  "Transfer ownership": "Transfer ownership",
  "Transfer properties and delete brand": "Transfer properties and delete brand",
  "Transfer properties and delete cluster": "Transfer properties and delete cluster",
  "Transfer property": "Transfer property",
  "Transfer this property to another brand": "Transfer this property to another brand",
  "Transfer this property to another cluster": "Transfer this property to another cluster",
  "Transfer to another brand": "Transfer to another brand",
  "Transfer to another cluster": "Transfer to another cluster",
  "Untitled page": "Untitled page",
  "URL": "URL",
  "URL contains": "URL contains",
  "URL equals": "URL equals",
  "Use clusters to visualize and filter your properties categorizing them by similar variables: location, hotel type, number of stars and even by number of rooms.": "Use clusters to visualize and filter your properties categorizing them by similar variables: location, hotel type, number of stars and even by number of rooms.",
  "User": "User",
  "User invited": "User invited",
  "User removed": "User removed",
  "User role was successfully changed.": "User role was successfully changed.",
  "User was successfully removed.": "User was successfully removed.",
  "Users": "Users",
  "Users invited": "Users invited",
  "Validating emails ...": "Validating emails ...",
  "Verify": "Verify",
  "View brand": "View brand",
  "View cluster": "View cluster",
  "View info": "View info",
  "View Property": "View Property",
  "View site": "View site",
  "Visualize and analyze your brand data classifying those properties within the same brand into one group.": "Visualize and analyze your brand data classifying those properties within the same brand into one group.",
  "We respect your privacy, therefore we will not share your personal information with third parties or partners.": "We respect your privacy, therefore we will not share your personal information with third parties or partners.",
  "We're having trouble connecting to the login provider. Please try again later or contact support via chat if the issue persists.": "We're having trouble connecting to the login provider. Please try again later or contact support via chat if the issue persists.",
  "Weekly": "Weekly",
  "Weekly:": "Weekly: ",
  "Welcome": "Welcome",
  "Welcome {0},": "Welcome {0},",
  "Welcome to THN": "Welcome to THN",
  "Wellness & Spa": "Wellness & Spa",
  "Widget data": "Widget data",
  "Without it, messages won’t be shown and no data will be collected.": "Without it, messages won’t be shown and no data will be collected.",
  "Without it, messages won\\’t be shown and no data will be collected.": "Without it, messages won\\’t be shown and no data will be collected.",
  "Write the number of rooms": "Write the number of rooms",
  "Yes, remove access": "Yes, remove access",
  "Yes, remove user": "Yes, remove user",
  "You are about to delete this brand": "You are about to delete this brand",
  "You are about to delete this cluster": "You are about to delete this cluster",
  "You are about to transfer the ownership to this user. Your role will change to Operator, and you will no longer be able to edit the account information.": "You are about to transfer the ownership to this user. Your role will change to Operator, and you will no longer be able to edit the account information.",
  "You can add it again later.": "You can add it again later.",
  "You can’t invite users that are already in the account": "You can’t invite users that are already in the account",
  "You haven't created any email notification yet": "You haven't created any email notification yet",
  "You will see brands here when an admin user creates them.": "You will see brands here when an admin user creates them.",
  "You will see clusters here when an admin creates them.": "You will see clusters here when an admin creates them.",
  "Your brand was successfully removed.": "Your brand was successfully removed.",
  "Your Brand was successfully updated.": "Your Brand was successfully updated.",
  "Your cluster was successfully removed.": "Your cluster was successfully removed.",
  "Your Cluster was successfully updated.": "Your cluster was successfully updated.",
  "Your new password has been successfully set": "Your new password has been successfully set",
  "Your password was successfully changed.": "Your password was successfully changed.",
  "Your profile was successfully updated.": "Your profile was successfully updated.",
  "Your Properties was successfully removed from brand.": "Your Properties was successfully removed from brand.",
  "Your Properties was successfully removed from cluster.": "Your Properties was successfully removed from cluster.",
  "Your properties was successfully transferred.": "Your properties was successfully transferred.",
  "Your property was successfully updated.": "Your property was successfully updated.",
  "Your site was created.": "Your site was created.",
  "Your site was successfully updated.": "Your site was successfully updated.",
  "Your verification session expired. Please sign in again.": "Your verification session expired. Please sign in again."
}